import FieldType from "./field-schema"
import GroupType from "./group-schema"
import EditorType from "./editor-schema"

// Example content type for a product
const ContentType = {
  type: "ContentType",
  groups: [
    {
      id: "config",
      label: "Naming",
      description: "Set the name and label for the content type",
      expanded: false,
    },
    {
      id: "fields",
      label: "Fields",
      description: "Fields describe the data structure of the content type",
    },
    {
      id: "groups",
      label: "Groups",
      description:
        "Group fields together for better organization and presentation",
    },
    {
      id: "editors",
      label: "Editor",
      description: "Add Additional editors to the content type",
    },
  ],
  fields: [
    {
      id: "type",
      type: "Text",
      label: "Type Name",
      description: "For example, FeatureItem, BlogPost, etc.",
      required: true,
      group: "config",
    },
    {
      id: "label",
      type: "Text",
      label: "Label",
      description: "What is this content type about? Shown in the editor.",
      group: "config",
    },
    {
      id: "thumbnail",
      type: "Image",
      formats: ["jpeg", "jpg", "png", "webp", "gif"],
      label: "Component Preview Image",
      description: "Show this component in action with a screenshot",
      group: "config",
    },
    {
      id: "fields",
      type: "Array",
      label: "Fields",
      item: FieldType,
      description: "Add fields to this content type",
      group: "fields",
    },
    {
      id: "groups",
      type: "Array",
      item: GroupType,
      label: "Groups",
      description: "Group fields together for better organization",
      group: "groups",
      multiple: true,
    },
    {
      id: "editors",
      type: "Array",
      item: EditorType,
      label: "Field Editor",
      description: "Additional editors for this content type",
      group: "editors",
      multiple: true,
    },
  ],
}

export default ContentType
